import styled from 'styled-components';

export const AppContent = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: ${props => props.theme.bgColor} 0% 0% no-repeat padding-box;
  overflow-x: hidden;

  @media screen and (max-width: 767px) {
    height: auto;
  }
`;
